import "./Header.css";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../Assets/images/logo.png";
import SmallLogo from "../../Assets/images/logo-small.png";
import NotificationAvatar from "../../Assets/images/icons/header-icon-05.svg";
import NoProfileAvatar from "../../Assets/images/profiles/avatar-01.jpg";
import { getAuth } from "firebase/auth";
import GetUser from "../../Controllers/Users/GetUser";
import Logout from "../../Controllers/Auth/Logout";
import PushNotifications from "../Notifications/Notifications";
import useRealsTimeNotifications from "../../Controllers/notifications/useRealTimeNotifications";
import UpdateNotificationStatus from "../../Controllers/notifications/UpdateNotificationStatus";

const Header = () => {
  const [CurrentAuth, setCurrentAuth] = useState({});
  const [ToggleNotifications, setToggleNotifications] = useState(false);
  const [ToggleUser, setToggleUser] = useState(false);

  const navigate = useNavigate();

  const ref = useRef();
  const UserDropDownRef = useRef();
  const notificationIcon = useRef();
  const profileDropDownRef = useRef();
  const [Notifications] = useRealsTimeNotifications();

  useEffect(() => {
    let userHandler = (e) => {
      if (profileDropDownRef?.current?.contains(e.target)) {
        return;
      }
      if (!UserDropDownRef?.current?.contains(e.target)) {
        setToggleUser(false);
      }
    };
    document.addEventListener("mousedown", userHandler);
  }, []);

  useEffect(() => {
    let handler = (e) => {
      if (notificationIcon?.current?.contains(e.target)) {
        return;
      }
      if (!ref?.current?.contains(e.target)) {
        setToggleNotifications(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        if (!user.emailVerified) {
          navigate("/email-verification");
          return;
        }
        const UserData = await GetUser(user?.uid);
        if (UserData?.IsVerified === 0) {
          navigate("/verification-pending");
          return;
        }

        setCurrentAuth(UserData);
      });
    }

    fetchData();
  }, []);

  return (
    <Fragment>
      {CurrentAuth.UserType === "admin" ? (
        <Fragment>
          <PushNotifications />
          {/* Header */}
          <div className="header">
            {/* Logo */}
            <div className="header-left">
              <Link
                to={`/user/${CurrentAuth.UserType}/dashboard`}
                className="logo"
              >
                <img src={Logo} alt="Logo" />
              </Link>
              <Link
                to={`/user${CurrentAuth.UserType}/dashboard`}
                className="logo logo-small"
              >
                <img src={SmallLogo} alt="Logo" width={30} height={30} />
              </Link>
            </div>
            {/* /Logo */}
            <div
              className="menu-toggle"
              onClick={() => {
                if (
                  document
                    .getElementById("root")
                    .classList.contains("mini-sidebar")
                ) {
                  document
                    .getElementById("root")
                    .classList.remove("mini-sidebar");
                  document
                    .getElementById("sidebar-submenu")
                    ?.classList.remove("d-none");
                  return;
                }
                document.getElementById("root").classList.add("mini-sidebar");

                document
                  .getElementById("sidebar-submenu")
                  ?.classList.remove("d-block");
              }}
            >
              <a id="toggle_btn">
                <i className="fas fa-bars" />
              </a>
            </div>
            {/* Search Bar */}
            <div className="top-nav-search">
              <form>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here"
                />
                <button className="btn" type="submit">
                  <i className="fas fa-search" />
                </button>
              </form>
            </div>
            {/* /Search Bar */}
            {/* Mobile Menu Toggle */}
            <a
              className="mobile_btn"
              id="mobile_btn"
              onClick={() => {
                if (document.body.classList.contains("slide-nav")) {
                  document.body.classList.remove("slide-nav");
                  return;
                }
                document.body.classList.add("slide-nav");
              }}
            >
              <i className="fas fa-bars" />
            </a>
            {/* /Mobile Menu Toggle */}
            {/* Header Right Menu */}
            <ul className="nav user-menu">
              {/* Notifications */}
              <li className="nav-item dropdown noti-dropdown me-2">
                <Link
                  className="nav-link header-nav-list"
                  ref={notificationIcon}
                  onClick={() => {
                    if (ToggleNotifications) {
                      setToggleNotifications(false);
                    } else {
                      setToggleNotifications(true);
                    }
                  }}
                >
                  <img src={NotificationAvatar} alt="" />
                </Link>
                <div
                  className={`dropdown-menu notifications ${
                    ToggleNotifications ? " show user-notifications" : ""
                  }`}
                  ref={ref}
                >
                  <div className="topnav-dropdown-header">
                    <span className="notification-title">Notifications</span>
                    {Notifications?.length > 0 && (
                      <a className="clear-noti"> Clear All </a>
                    )}
                  </div>
                  <div className="noti-content">
                    {Notifications && Notifications.length > 0 ? (
                      <ul className="notification-list">
                        {Notifications &&
                          Notifications.map((notification) => (
                            <li
                              onClick={() =>
                                UpdateNotificationStatus(notification.id)
                              }
                              className={`notification-message ${
                                notification.is_seen
                                  ? "parent-read-notifications"
                                  : "parent-unread-notifications"
                              } `}
                            >
                              <a href="#">
                                <div className="media d-flex">
                                  <span className="avatar avatar-sm flex-shrink-0">
                                    <img
                                      className="avatar-img rounded-circle"
                                      alt="User Image"
                                      src={require("../../Assets/images/profiles/avatar-02.jpg")}
                                    />
                                  </span>
                                  <div className="media-body flex-grow-1">
                                    <p className="noti-details">
                                      <span className="noti-title">
                                        {notification.description}
                                      </span>
                                    </p>
                                    <p className="noti-time">
                                      <span className="notification-time">
                                        {notification.createdAt
                                          ?.toDate()
                                          .toLocaleString()}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </a>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <div className="no-notification">
                        <p>No Notifications</p>
                      </div>
                    )}
                  </div>
                  {Notifications?.length > 0 && (
                    <div className="topnav-dropdown-footer">
                      <link
                        to={`/user/${CurrentAuth.UserType}/all-notifications`}
                      >
                        View all Notifications
                      </link>
                    </div>
                  )}
                </div>
              </li>
              {/* /Notifications */}

              {/* User Menu */}
              <li
                className="nav-item dropdown has-arrow new-user-menus"
                onClick={() => {
                  setToggleUser(!ToggleUser);
                }}
              >
                <a
                  href="#"
                  className="dropdown-toggle nav-link"
                  data-bs-toggle="dropdown"
                  ref={profileDropDownRef}
                >
                  <span className="user-img">
                    <img
                      className="rounded-circle"
                      src={
                        getAuth().currentUser.photoURL
                          ? getAuth().currentUser.photoURL
                          : NoProfileAvatar
                      }
                      width={31}
                      alt={
                        CurrentAuth.FirstName?.slice(1) +
                        " " +
                        CurrentAuth.LastName?.charAt(0).toUpperCase() +
                        CurrentAuth.LastName?.slice(1)
                      }
                    />
                    <div className="user-text">
                      <h6>
                        {CurrentAuth.FirstName?.charAt(0).toUpperCase() +
                          CurrentAuth.FirstName?.slice(1) +
                          " " +
                          CurrentAuth.LastName?.charAt(0).toUpperCase() +
                          CurrentAuth.LastName?.slice(1)}
                      </h6>
                      <p className="text-muted mb-0">
                        {CurrentAuth.UserType?.toUpperCase()}
                      </p>
                    </div>
                  </span>
                </a>
                <div
                  ref={UserDropDownRef}
                  className={`dropdown-menu ${
                    ToggleUser ? " show user-profile-dropdown" : ""
                  }`}
                >
                  <div className="user-header">
                    <div className="avatar avatar-sm">
                      <img
                        src={
                          getAuth().currentUser.photoURL
                            ? getAuth().currentUser.photoURL
                            : require("../../Assets/images/profiles/avatar-01.jpg")
                        }
                        alt="User Image"
                        className="avatar-img rounded-circle"
                      />
                    </div>
                    <div className="user-text">
                      <h6>
                        {CurrentAuth.FirstName + " " + CurrentAuth.LastName}
                      </h6>
                      <p className="text-muted mb-0">
                        {CurrentAuth.UserType?.toUpperCase()}
                      </p>
                    </div>
                  </div>
                  <Link className="dropdown-item" to="/user/admin/profile">
                    My Profile
                  </Link>
                  {/* <a className="dropdown-item" href="inbox.html">
                Inbox
              </a> */}
                  <a
                    className="dropdown-item"
                    onClick={async () => {
                      let resp = await Logout();
                      if (resp) {
                        navigate("/login");
                      }
                    }}
                  >
                    Logout
                  </a>
                </div>
              </li>
              {/* /User Menu */}
            </ul>
            {/* /Header Right Menu */}
          </div>
          {/* /Header */}
        </Fragment>
      ) : CurrentAuth.UserType === "teacher" ? (
        <Fragment>
          <PushNotifications />
          {/* Header */}
          <div className="header">
            {/* Logo */}
            <div className="header-left">
              <Link
                to={`/user/${CurrentAuth.UserType}/dashboard`}
                className="logo"
              >
                <img src={Logo} alt="Logo" />
              </Link>
              <Link
                to={`/user${CurrentAuth.UserType}/dashboard`}
                className="logo logo-small"
              >
                <img src={SmallLogo} alt="Logo" width={30} height={30} />
              </Link>
            </div>
            {/* /Logo */}
            <div
              className="menu-toggle"
              onClick={() => {
                if (
                  document
                    .getElementById("root")
                    .classList.contains("mini-sidebar")
                ) {
                  document
                    .getElementById("root")
                    .classList.remove("mini-sidebar");
                  document
                    .getElementById("sidebar-submenu")
                    ?.classList.remove("d-none");
                  return;
                }
                document.getElementById("root").classList.add("mini-sidebar");

                document
                  .getElementById("sidebar-submenu")
                  ?.classList.remove("d-block");
              }}
            >
              <a id="toggle_btn">
                <i className="fas fa-bars" />
              </a>
            </div>
            {/* Search Bar */}
            <div className="top-nav-search">
              <form>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here"
                />
                <button className="btn" type="submit">
                  <i className="fas fa-search" />
                </button>
              </form>
            </div>
            {/* /Search Bar */}
            {/* Mobile Menu Toggle */}
            <a
              className="mobile_btn"
              id="mobile_btn"
              onClick={() => {
                if (document.body.classList.contains("slide-nav")) {
                  document.body.classList.remove("slide-nav");
                  return;
                }
                document.body.classList.add("slide-nav");
              }}
            >
              <i className="fas fa-bars" />
            </a>
            {/* /Mobile Menu Toggle */}
            {/* Header Right Menu */}
            <ul className="nav user-menu">
              {/* Notifications */}
              <li className="nav-item dropdown noti-dropdown me-2">
                <Link
                  className="nav-link header-nav-list"
                  ref={notificationIcon}
                  onClick={() => {
                    if (ToggleNotifications) {
                      setToggleNotifications(false);
                    } else {
                      setToggleNotifications(true);
                    }
                  }}
                >
                  <img src={NotificationAvatar} alt="" />
                </Link>
                <div
                  className={`dropdown-menu notifications ${
                    ToggleNotifications ? " show user-notifications" : ""
                  }`}
                  ref={ref}
                >
                  <div className="topnav-dropdown-header">
                    <span className="notification-title">Notifications</span>
                    {Notifications?.length > 0 && (
                      <a className="clear-noti"> Clear All </a>
                    )}
                  </div>
                  <div className="noti-content">
                    {Notifications && Notifications.length > 0 ? (
                      <ul className="notification-list">
                        {Notifications &&
                          Notifications.map((notification) => (
                            <li
                              onClick={() =>
                                UpdateNotificationStatus(notification.id)
                              }
                              className={`notification-message ${
                                notification.is_seen
                                  ? "parent-read-notifications"
                                  : "parent-unread-notifications"
                              } `}
                            >
                              <a href="#">
                                <div className="media d-flex">
                                  <span className="avatar avatar-sm flex-shrink-0">
                                    <img
                                      className="avatar-img rounded-circle"
                                      alt="User Image"
                                      src={require("../../Assets/images/profiles/avatar-02.jpg")}
                                    />
                                  </span>
                                  <div className="media-body flex-grow-1">
                                    <p className="noti-details">
                                      <span className="noti-title">
                                        {notification.description}
                                      </span>
                                    </p>
                                    <p className="noti-time">
                                      <span className="notification-time">
                                        {notification.createdAt
                                          ?.toDate()
                                          .toLocaleString()}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </a>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <div className="no-notification">
                        <p>No Notifications</p>
                      </div>
                    )}
                  </div>
                  {Notifications?.length > 0 && (
                    <div className="topnav-dropdown-footer">
                      <Link
                        to={`/user/${CurrentAuth.UserType}/all-notifications`}
                      >
                        View all Notifications
                      </Link>
                    </div>
                  )}
                </div>
              </li>
              {/* /Notifications */}

              {/* User Menu */}
              <li
                className="nav-item dropdown has-arrow new-user-menus"
                onClick={() => {
                  setToggleUser(!ToggleUser);
                }}
              >
                <a
                  href="#"
                  className="dropdown-toggle nav-link"
                  data-bs-toggle="dropdown"
                  ref={profileDropDownRef}
                >
                  <span className="user-img">
                    <img
                      className="rounded-circle"
                      src={
                        getAuth().currentUser.photoURL
                          ? getAuth().currentUser.photoURL
                          : NoProfileAvatar
                      }
                      width={31}
                      alt={
                        CurrentAuth.FirstName?.slice(1) +
                        " " +
                        CurrentAuth.LastName?.charAt(0).toUpperCase() +
                        CurrentAuth.LastName?.slice(1)
                      }
                    />
                    <div className="user-text">
                      <h6>
                        {CurrentAuth.FirstName?.charAt(0).toUpperCase() +
                          CurrentAuth.FirstName?.slice(1) +
                          " " +
                          CurrentAuth.LastName?.charAt(0).toUpperCase() +
                          CurrentAuth.LastName?.slice(1)}
                      </h6>
                      <p className="text-muted mb-0">
                        {CurrentAuth.UserType?.toUpperCase()}
                      </p>
                    </div>
                  </span>
                </a>
                <div
                  ref={UserDropDownRef}
                  className={`dropdown-menu ${
                    ToggleUser ? " show user-profile-dropdown" : ""
                  }`}
                >
                  <div className="user-header">
                    <div className="avatar avatar-sm">
                      <img
                        src={
                          getAuth().currentUser.photoURL
                            ? getAuth().currentUser.photoURL
                            : require("../../Assets/images/profiles/avatar-01.jpg")
                        }
                        alt="User Image"
                        className="avatar-img rounded-circle"
                      />
                    </div>
                    <div className="user-text">
                      <h6>
                        {CurrentAuth.FirstName + " " + CurrentAuth.LastName}
                      </h6>
                      <p className="text-muted mb-0">
                        {CurrentAuth.UserType?.toUpperCase()}
                      </p>
                    </div>
                  </div>
                  <Link
                    className="dropdown-item"
                    to={`/user/${CurrentAuth.UserType}/profile`}
                  >
                    My Profile
                  </Link>
                  {/* <a className="dropdown-item" href="inbox.html">
                Inbox
              </a> */}
                  <Link
                    className="dropdown-item"
                    onClick={async () => {
                      let resp = await Logout();
                      if (resp) {
                        navigate("/login");
                      }
                    }}
                  >
                    Logout
                  </Link>
                </div>
              </li>
              {/* /User Menu */}
            </ul>
            {/* /Header Right Menu */}
          </div>
          {/* /Header */}
        </Fragment>
      ) : CurrentAuth.UserType === "student" ? (
        <Fragment>
          <PushNotifications />
          {/* Header */}
          <div className="header">
            {/* Logo */}
            <div className="header-left">
              <Link
                to={`/user/${CurrentAuth.UserType}/dashboard`}
                className="logo"
              >
                <img src={Logo} alt="Logo" />
              </Link>
              <Link
                to={`/user${CurrentAuth.UserType}/dashboard`}
                className="logo logo-small"
              >
                <img src={SmallLogo} alt="Logo" width={30} height={30} />
              </Link>
            </div>
            {/* /Logo */}
            <div
              className="menu-toggle"
              onClick={() => {
                if (
                  document
                    .getElementById("root")
                    .classList.contains("mini-sidebar")
                ) {
                  document
                    .getElementById("root")
                    .classList.remove("mini-sidebar");
                  document
                    .getElementById("sidebar-submenu")
                    ?.classList.remove("d-none");
                  return;
                }
                document.getElementById("root").classList.add("mini-sidebar");

                document
                  .getElementById("sidebar-submenu")
                  ?.classList.remove("d-block");
              }}
            >
              <a id="toggle_btn">
                <i className="fas fa-bars" />
              </a>
            </div>
            {/* Search Bar */}
            <div className="top-nav-search">
              <form>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here"
                />
                <button className="btn" type="submit">
                  <i className="fas fa-search" />
                </button>
              </form>
            </div>
            {/* /Search Bar */}
            {/* Mobile Menu Toggle */}
            <a
              className="mobile_btn"
              id="mobile_btn"
              onClick={() => {
                if (document.body.classList.contains("slide-nav")) {
                  document.body.classList.remove("slide-nav");
                  return;
                }
                document.body.classList.add("slide-nav");
              }}
            >
              <i className="fas fa-bars" />
            </a>
            {/* /Mobile Menu Toggle */}
            {/* Header Right Menu */}
            <ul className="nav user-menu">
              {/* Notifications */}
              <li className="nav-item dropdown noti-dropdown me-2">
                <Link
                  className="nav-link header-nav-list"
                  ref={notificationIcon}
                  onClick={() => {
                    if (ToggleNotifications) {
                      setToggleNotifications(false);
                    } else {
                      setToggleNotifications(true);
                    }
                  }}
                >
                  <img src={NotificationAvatar} alt="" />
                </Link>
                <div
                  className={`dropdown-menu notifications ${
                    ToggleNotifications ? " show user-notifications" : ""
                  }`}
                  ref={ref}
                >
                  <div className="topnav-dropdown-header">
                    <span className="notification-title">Notifications</span>
                    {Notifications?.length > 0 && (
                      <a className="clear-noti"> Clear All </a>
                    )}
                  </div>
                  <div className="noti-content">
                    {Notifications && Notifications.length > 0 ? (
                      <ul className="notification-list">
                        {Notifications &&
                          Notifications.map((notification) => (
                            <li
                              onClick={() =>
                                UpdateNotificationStatus(notification.id)
                              }
                              className={`notification-message ${
                                notification.is_seen
                                  ? "parent-read-notifications"
                                  : "parent-unread-notifications"
                              } `}
                            >
                              <a href="#">
                                <div className="media d-flex">
                                  <span className="avatar avatar-sm flex-shrink-0">
                                    <img
                                      className="avatar-img rounded-circle"
                                      alt="User Image"
                                      src={require("../../Assets/images/profiles/avatar-02.jpg")}
                                    />
                                  </span>
                                  <div className="media-body flex-grow-1">
                                    <p className="noti-details">
                                      <span className="noti-title">
                                        {notification.description}
                                      </span>
                                    </p>
                                    <p className="noti-time">
                                      <span className="notification-time">
                                        {notification.createdAt
                                          ?.toDate()
                                          .toLocaleString()}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </a>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <div className="no-notification">
                        <p>No Notifications</p>
                      </div>
                    )}
                  </div>
                  {Notifications?.length > 0 && (
                    <div className="topnav-dropdown-footer">
                      <Link
                        to={`/user/${CurrentAuth.UserType}/all-notifications`}
                      >
                        View all Notifications
                      </Link>
                    </div>
                  )}
                </div>
              </li>
              {/* /Notifications */}

              {/* User Menu */}
              <li
                className="nav-item dropdown has-arrow new-user-menus"
                onClick={() => {
                  setToggleUser(!ToggleUser);
                }}
              >
                <a
                  href="#"
                  className="dropdown-toggle nav-link"
                  data-bs-toggle="dropdown"
                  ref={profileDropDownRef}
                >
                  <span className="user-img">
                    <img
                      className="rounded-circle"
                      src={
                        getAuth().currentUser.photoURL
                          ? getAuth().currentUser.photoURL
                          : NoProfileAvatar
                      }
                      width={31}
                      alt={
                        CurrentAuth.FirstName?.slice(1) +
                        " " +
                        CurrentAuth.LastName?.charAt(0).toUpperCase() +
                        CurrentAuth.LastName?.slice(1)
                      }
                    />
                    <div className="user-text">
                      <h6>
                        {CurrentAuth.FirstName?.charAt(0).toUpperCase() +
                          CurrentAuth.FirstName?.slice(1) +
                          " " +
                          CurrentAuth.LastName?.charAt(0).toUpperCase() +
                          CurrentAuth.LastName?.slice(1)}
                      </h6>
                      <p className="text-muted mb-0">
                        {CurrentAuth.UserType?.toUpperCase()}
                      </p>
                    </div>
                  </span>
                </a>
                <div
                  ref={UserDropDownRef}
                  className={`dropdown-menu ${
                    ToggleUser ? " show user-profile-dropdown" : ""
                  }`}
                >
                  <div className="user-header">
                    <div className="avatar avatar-sm">
                      <img
                        src={
                          getAuth().currentUser.photoURL
                            ? getAuth().currentUser.photoURL
                            : require("../../Assets/images/profiles/avatar-01.jpg")
                        }
                        alt="User Image"
                        className="avatar-img rounded-circle"
                      />
                    </div>
                    <div className="user-text">
                      <h6>
                        {CurrentAuth.FirstName + " " + CurrentAuth.LastName}
                      </h6>
                      <p className="text-muted mb-0">
                        {CurrentAuth.UserType?.toUpperCase()}
                      </p>
                    </div>
                  </div>
                  <Link
                    className="dropdown-item"
                    to={`/user/${CurrentAuth.UserType}/profile`}
                  >
                    My Profile
                  </Link>
                  {/* <a className="dropdown-item" href="inbox.html">
                Inbox
              </a> */}
                  <Link
                    className="dropdown-item"
                    onClick={async () => {
                      let resp = await Logout();
                      if (resp) {
                        navigate("/login");
                      }
                    }}
                  >
                    Logout
                  </Link>
                </div>
              </li>
              {/* /User Menu */}
            </ul>
            {/* /Header Right Menu */}
          </div>
          {/* /Header */}
        </Fragment>
      ) : CurrentAuth.UserType === "parent" ? (
        <Fragment>
          <PushNotifications />
          {/* Header */}
          <div className="header">
            {/* Logo */}
            <div className="header-left">
              <Link
                to={`/user/${CurrentAuth.UserType}/dashboard`}
                className="logo"
              >
                <img src={Logo} alt="Logo" />
              </Link>
              <Link
                to={`/user${CurrentAuth.UserType}/dashboard`}
                className="logo logo-small"
              >
                <img src={SmallLogo} alt="Logo" width={30} height={30} />
              </Link>
            </div>
            {/* /Logo */}
            <div
              className="menu-toggle"
              onClick={() => {
                if (
                  document
                    .getElementById("root")
                    .classList.contains("mini-sidebar")
                ) {
                  document
                    .getElementById("root")
                    .classList.remove("mini-sidebar");
                  document
                    .getElementById("sidebar-submenu")
                    ?.classList.remove("d-none");
                  return;
                }
                document.getElementById("root").classList.add("mini-sidebar");

                document
                  .getElementById("sidebar-submenu")
                  ?.classList.remove("d-block");
              }}
            >
              <a id="toggle_btn">
                <i className="fas fa-bars" />
              </a>
            </div>
            {/* Search Bar */}
            <div className="top-nav-search">
              <form>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here"
                />
                <button className="btn" type="submit">
                  <i className="fas fa-search" />
                </button>
              </form>
            </div>
            {/* /Search Bar */}
            {/* Mobile Menu Toggle */}
            <a
              className="mobile_btn"
              id="mobile_btn"
              onClick={() => {
                if (document.body.classList.contains("slide-nav")) {
                  document.body.classList.remove("slide-nav");
                  return;
                }
                document.body.classList.add("slide-nav");
              }}
            >
              <i className="fas fa-bars" />
            </a>
            {/* /Mobile Menu Toggle */}
            {/* Header Right Menu */}
            <ul className="nav user-menu">
              {/* Notifications */}
              <li className="nav-item dropdown noti-dropdown me-2">
                <Link
                  className="nav-link header-nav-list"
                  ref={notificationIcon}
                  onClick={() => {
                    if (ToggleNotifications) {
                      setToggleNotifications(false);
                    } else {
                      setToggleNotifications(true);
                    }
                  }}
                >
                  <img src={NotificationAvatar} alt="" />
                </Link>
                <div
                  className={`dropdown-menu notifications ${
                    ToggleNotifications ? " show user-notifications" : ""
                  }`}
                  ref={ref}
                >
                  <div className="topnav-dropdown-header">
                    <span className="notification-title">Notifications</span>
                    {Notifications?.length > 0 && (
                      <a className="clear-noti"> Clear All </a>
                    )}
                  </div>
                  <div className="noti-content">
                    {Notifications && Notifications.length > 0 ? (
                      <ul className="notification-list">
                        {Notifications &&
                          Notifications.map((notification) => (
                            <li
                              onClick={() =>
                                UpdateNotificationStatus(notification.id)
                              }
                              className={`notification-message ${
                                notification.is_seen
                                  ? "parent-read-notifications"
                                  : "parent-unread-notifications"
                              } `}
                            >
                              <a href="#">
                                <div className="media d-flex">
                                  <span className="avatar avatar-sm flex-shrink-0">
                                    <img
                                      className="avatar-img rounded-circle"
                                      alt="User Image"
                                      src={require("../../Assets/images/profiles/avatar-02.jpg")}
                                    />
                                  </span>
                                  <div className="media-body flex-grow-1">
                                    <p className="noti-details">
                                      <span className="noti-title">
                                        {notification.description}
                                      </span>
                                    </p>
                                    <p className="noti-time">
                                      <span className="notification-time">
                                        {notification.createdAt
                                          ?.toDate()
                                          .toLocaleString()}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </a>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <div className="no-notification">
                        <p>No Notifications</p>
                      </div>
                    )}
                  </div>
                  {Notifications?.length > 0 && (
                    <div className="topnav-dropdown-footer">
                      <Link
                        to={`/user/${CurrentAuth.UserType}/all-notifications`}
                      >
                        View all Notifications
                      </Link>
                    </div>
                  )}
                </div>
              </li>
              {/* /Notifications */}

              {/* User Menu */}
              <li
                className="nav-item dropdown has-arrow new-user-menus"
                onClick={() => {
                  setToggleUser(!ToggleUser);
                }}
              >
                <a
                  href="#"
                  className="dropdown-toggle nav-link"
                  data-bs-toggle="dropdown"
                  ref={profileDropDownRef}
                >
                  <span className="user-img">
                    <img
                      className="rounded-circle"
                      src={
                        getAuth().currentUser.photoURL
                          ? getAuth().currentUser.photoURL
                          : NoProfileAvatar
                      }
                      width={31}
                      alt={
                        CurrentAuth.FirstName?.slice(1) +
                        " " +
                        CurrentAuth.LastName?.charAt(0).toUpperCase() +
                        CurrentAuth.LastName?.slice(1)
                      }
                    />
                    <div className="user-text">
                      <h6>
                        {CurrentAuth.FirstName?.charAt(0).toUpperCase() +
                          CurrentAuth.FirstName?.slice(1) +
                          " " +
                          CurrentAuth.LastName?.charAt(0).toUpperCase() +
                          CurrentAuth.LastName?.slice(1)}
                      </h6>
                      <p className="text-muted mb-0">
                        {CurrentAuth.UserType?.toUpperCase()}
                      </p>
                    </div>
                  </span>
                </a>
                <div
                  ref={UserDropDownRef}
                  className={`dropdown-menu ${
                    ToggleUser ? " show user-profile-dropdown" : ""
                  }`}
                >
                  <div className="user-header">
                    <div className="avatar avatar-sm">
                      <img
                        src={
                          getAuth().currentUser.photoURL
                            ? getAuth().currentUser.photoURL
                            : require("../../Assets/images/profiles/avatar-01.jpg")
                        }
                        alt="User Image"
                        className="avatar-img rounded-circle"
                      />
                    </div>
                    <div className="user-text">
                      <h6>
                        {CurrentAuth.FirstName + " " + CurrentAuth.LastName}
                      </h6>
                      <p className="text-muted mb-0">
                        {CurrentAuth.UserType?.toUpperCase()}
                      </p>
                    </div>
                  </div>
                  <Link
                    className="dropdown-item"
                    to={`/user/${CurrentAuth.UserType}/profile`}
                  >
                    My Profile
                  </Link>
                  {/* <a className="dropdown-item" href="inbox.html">
                Inbox
              </a> */}
                  <Link
                    className="dropdown-item"
                    onClick={async () => {
                      let resp = await Logout();
                      if (resp) {
                        navigate("/login");
                      }
                    }}
                  >
                    Logout
                  </Link>
                </div>
              </li>
              {/* /User Menu */}
            </ul>
            {/* /Header Right Menu */}
          </div>
          {/* /Header */}
        </Fragment>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default Header;
